import React from 'react';
import { Layers, AlertTriangle, BrainCircuit } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Layers className="w-8 h-8 text-gold-500" data-id="element-480" />,
    title: 'Todo a medias',
    description: 'Tienes mil cosas abiertas: inbox, reuniones, mensajes, pendientes. Trabajas… pero no avanzas. Respondes… pero no construyes.'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-gold-500" data-id="element-481" />,
    title: 'Modo alarma constante',
    description: "Tu cerebro entra en modo alarma: 'Me falta esto', 'No respondí aquello', 'Se me olvidó lo otro'. El ciclo: saturación → multitarea → nada se cierra → más estrés."
  }, {
    icon: <BrainCircuit className="w-8 h-8 text-gold-500" data-id="element-482" />,
    title: 'Tu cabeza no descansa',
    description: 'Apagas la computadora… y tu mente sigue prendida. Porque no descansas con descanso. Descansas con cierre visible.'
  }];
  return <section className="py-24 bg-dark-900 relative overflow-hidden" data-id="element-483">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-800 to-transparent" data-id="element-484"></div>

      <div className="max-w-7xl mx-auto px-4" data-id="element-485">
        <div className="text-center mb-16" data-id="element-486">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-487">
            <span className="text-white" data-id="element-488">Si hoy </span>
            <span className="text-gold-500 italic font-serif" data-id="element-489">
              te sientes así...
            </span>
          </h2>
          <p className="text-gray-300 max-w-3xl mx-auto text-lg leading-relaxed" data-id="element-490">
            Lo peor no es estar ocupado. Lo peor es terminar el día con la
            sensación de que{' '}
            <span className="text-white font-medium" data-id="element-491">no cerraste nada</span>.
          </p>
        </div>

        <div className="mb-16 max-w-4xl mx-auto" data-id="element-492">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-493">
            <img src="https://cdn.magicpatterns.com/uploads/vSZHqSNAUNtfAopojSk9Eq/1_Stressful_office_at_twilight.png" alt="Oficina caótica con estrés laboral" className="w-full h-auto" data-id="element-494" />
            <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent" data-id="element-495"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-496">
          {problems.map((problem, index) => <div key={index} className="bg-dark-800 p-8 rounded-2xl border border-white/5 hover:border-gold-500/30 transition-all duration-300 hover:-translate-y-1 group" data-id="element-497">
              <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-white/10" data-id="element-498">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-499">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-500">
                {problem.description}
              </p>
            </div>)}
        </div>

        <div className="text-center max-w-3xl mx-auto bg-white/5 border border-gold-500/20 rounded-2xl p-8" data-id="element-501">
          <p className="text-xl text-gray-300 mb-4" data-id="element-502">
            Si esto te está pasando,{' '}
            <span className="text-white font-semibold" data-id="element-503">
              no es porque te falte disciplina
            </span>
            .
          </p>
          <p className="text-2xl font-serif text-gold-500 italic" data-id="element-504">
            Tu problema es más simple: Te falta cierre.
          </p>
        </div>
      </div>
    </section>;
}